<template>
  <el-dialog :title="popType==3?(isServiceTeacher?'下级成员':'团队调整'):(isServiceTeacher?'大客户':'客户')+'调整'" :visible.sync="formVisible" width="1000px" :close-on-click-modal="false">
    <div class="flexs">
      <Title :isLine="false">{{popType==3?(isServiceTeacher?'下级成员':'团队调整'):(isServiceTeacher?'大客户':'客户')}}</Title>
      <!-- <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-if="popType==3"
        style="margin: 0 20px 20px;">添加团队</el-button> -->
    </div>
    <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" max-height="300">
      <el-table-column :label="popType==3?'老师信息':(isServiceTeacher?'大客户':'客户')+'信息'" prop="name" align="center" width="160" fixed>
        <template slot-scope="{row}">
          <div @click="handleShow(row,2)">
            <el-link type="primary">{{popType==3?row.realName:row.name}}</el-link><br />
            <el-link type="primary">{{popType==3?row.mobile:row.pho}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="身份" prop="levelName" align="center" />
      <el-table-column label="所属区域" prop="orderNo" align="center" width="200" v-if="popType==7">
        <template slot-scope="{row}">
          {{row.addrProvinceName}}{{row.addrCityName}}{{row.addrAreaName}}
        </template>
      </el-table-column>
      <el-table-column label="加入时间" prop="createdTime" sortable="custom" align="center" width="200" />
    </el-table>
    <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    <Title :isLine="false" class="mt10">移除{{popType==3?'团队':(isServiceTeacher?'大客户':'客户')}}</Title>
    <div v-for="(item,index) in form.childDetail" :key="index" class="full-box">
      <div class="select-container">
        <el-checkbox v-model="item.isAllSelected" @change="handleCheckboxChange(item)" class="select-all-checkbox" :indeterminate="isIndeterminate(item)">
          全选
        </el-checkbox>
        <el-select v-model="item.id" placeholder="请选择需要移除的团队" multiple filterable clearable size="small" v-if="popType==3" collapse-tags @change="technicianChange">
          <el-option v-for="(it,index) in options.customerOptions" :key="index" :label="it.realName + '(' + it.levelName +')' + it.mobile" :value="it.id"></el-option>
        </el-select>
        <el-select v-model="item.id" placeholder="请选择需要移除的客户" collapse-tags filterable multiple clearable size="small" v-else @change="customerChange">
          <el-option v-for="(it,index) in options.customerOptions" :key="index" :label="it.name + '(' + it.levelName +')' + it.pho" :value="it.id"></el-option>
        </el-select>
      </div>
      <el-select v-model="item.parentId" placeholder="请选择老师" clearable size="small" v-if="popType==3" filterable :filter-method="technicalFilter" @blur="handleTechnical()">
        <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.realName} (${it.mobile})`" :value="it.id"></el-option>
      </el-select>
      <el-select v-model="item.technicianId" placeholder="请选择老师" clearable size="small" v-else filterable :filter-method="technicalFilter" @blur="handleTechnical()">
        <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.realName} (${it.mobile})`" :value="it.id"></el-option>
      </el-select>
      <div class="full-icon">
        <i class="el-icon-plus" @click="handleAddCustomer"></i>
        <i class="el-icon-minus" @click="handleDeleteCustomer(index)"></i>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false,tabType=1">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import clientListApi from '@/api/client/clientList'
function initFormBean() {
  const formBean = {
    radio1: null,
    radio2: null,
    radio3: null,
    areaList: [],
    childDetail: []
  }
  return formBean
}
export default {
  props: ['popType', 'isServiceTeacher'],
  data() {
    return {
      formVisible: false,
      form: initFormBean(),
      listLoading: true,
      isLoading: false,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      list: [],
      options: {
        identityOptions: [],
        customerOptions: []
      },
      obj: {
        id: [],
      }
    }
  },
  mounted() {
    // console.log('==============');
    // this.doQueryList({})
  },
  methods: {
    async technicianChange(e) {
      // 更新复选框状态
      this.updateCheckboxState(this.form.childDetail.find(item => item.id === e))
      // if(e.length){
      //   let arr=e.map(item=>{
      //     return this.options.customerOptions.find(i=>i.id==item).levelId*1
      //   })
      //   await this.handleTechnical(Math.min(...arr))
      // }else{
      //   await this.handleTechnical()
      // }
      // console.log('e: ',e,this.options.identityOptions,this.options.customerOptions,arr);
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
      this.options.identityOptions = []
      this.options.customerOptions = []
    },
    handleUpdate(data) {
      this.resetForm()
      this.form = {
        ...this.form,
        ...data.row
      }
      console.log('this.form: --------', this.form, this.popType, data);
      this.formVisible = true
      this.$nextTick(() => {
        // this.$refs['dataForm'].clearValidate()
        this.doQueryList({})
        this.handleTechnical()
        if (this.popType == 3) {
          this.$set(this.obj, 'parentId', '')
          this.$set(this.obj, 'isAllSelected', false)
          this.getTeam()
        } else {
          this.$set(this.obj, 'technicianId', '')
          this.$set(this.obj, 'isAllSelected', false)
          this.getClient()
        }
        console.log('this.obj: ', this.obj);
        this.form.childDetail.push({ ...JSON.parse(JSON.stringify(this.obj)) })
      })
    },
    //指定分配 团队
    getTeam() {
      let obj = {
        parentId: this.form.id,
        status: 10
      }
      if (this.isServiceTeacher) {
        obj.levelIsBigCustomer = true
      }
      technicianInfoApi.listForMini(obj).then(({
        data
      }) => {
        this.options.customerOptions = data
      })
    },
    // 指定 客户
    getClient() {
      let obj = {}
      if (this.isServiceTeacher) {
        obj.techInfoIdForBig = this.form.id
        obj.levelIsBigCustomer = true
      } else {
        obj.technicianId = this.form.id
      }
      clientListApi.listForMini(obj).then(({
        data
      }) => {
        this.options.customerOptions = data
      })
    },
    technicalFilter(e) {
      this.handleTechnical(e)
    },
    // 获取技术老师
    handleTechnical(val) {
      //status  10 已入职  20  离职交接  30 已离职
      let obj = {
        status: 10,
        pageNo: 1,
        pageSize: 100,
        realName: val
      }
      if (this.isServiceTeacher) {
        obj.levelIsBigCustomer = true
      }
      // if(val){
      //   obj.maxLevelId=val
      // }
      technicianInfoApi.listPageForMini(obj).then(({
        data
      }) => {
        this.options.identityOptions = data.list.filter(i => i.userId != this.form.userId)
      })
    },
    formatCascaderData(data) {
      return data.reduce((data, item) => (data.push(...item.id.map(id => ({ ...item, id }))), data), [])
    },
    // 确定
    async doCreate() {
      let arr = this.formatCascaderData(this.form.childDetail)
      this.isLoading = true
      if (this.popType == 3) {
        // let Ins = this.isServiceTeacher ? technicianInfoApi.transferForBig : technicianInfoApi.makeTransfer
        await technicianInfoApi.makeTransfer({
          detail: arr,
          id: this.form.id
        }).then(() => {
          this.$message.success('操作成功')
          this.formVisible = false;
          this.$emit('created')
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      } else {
        let Ins = this.isServiceTeacher ? clientListApi.makeTransferForBig : clientListApi.makeTransfer
        await Ins({
          detail: arr,
          technicianId: this.form.id
        }).then(() => {
          this.$message.success('操作成功')
          this.formVisible = false;
          this.$emit('created')
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      }
    },
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      if (this.popType == 3) {
        this.query.parentId = this.form.id
      } else {
        if (this.isServiceTeacher) {
          this.query.techInfoIdForBig = this.form.id
        } else {
          this.query.technicianId = this.form.id
        }
      }
      if(this.isServiceTeacher){
        this.query.levelIsBigCustomer = true
      }
      // this.clacPrams()
      this.listLoading = true
      if (this.popType == 3) {
        return technicianInfoApi.fetchList(this.query)
          .then(({ data }) => {
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      } else {
        return clientListApi.getListPageForMini(this.query)
          .then(({ data }) => {
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      }

    },
    handleDeleteCustomer(index) {
      if (this.form.childDetail.length <= 1) return
      this.form.childDetail.splice(index, 1)
    },
    handleAddCustomer() {
      const newItem = JSON.parse(JSON.stringify(this.obj))
      newItem.isAllSelected = false
      this.form.childDetail.push(newItem)
      console.log('this.form.childDetail: ', this.form.childDetail);
    },
    handleSelectAll(item, isTeam) {
      if (isTeam) {
        // 团队全选
        const allIds = this.options.customerOptions.map(option => option.id)
        this.$set(item, 'id', allIds)
      } else {
        // 客户全选
        const allIds = this.options.customerOptions.map(option => option.id)
        this.$set(item, 'id', allIds)
      }
    },
    customerChange(e) {
      // 更新复选框状态
      this.updateCheckboxState(this.form.childDetail.find(item => item.id === e))
    },
    // 判断是否全选
    isAllSelected(item) {
      if (!this.options.customerOptions.length) return false
      return item.id && item.id.length === this.options.customerOptions.length
    },
    // 判断是否为半选状态
    isIndeterminate(item) {
      if (!this.options.customerOptions.length) return false
      return item.id && item.id.length > 0 && item.id.length < this.options.customerOptions.length
    },
    // 处理复选框变化
    handleCheckboxChange(item) {
      if (item.isAllSelected) {
        // 全选
        const allIds = this.options.customerOptions.map(option => option.id)
        this.$set(item, 'id', allIds)
      } else {
        // 取消全选
        this.$set(item, 'id', [])
      }
    },
    // 更新复选框状态
    updateCheckboxState(item) {
      if (!item) return
      this.$set(item, 'isAllSelected', this.isAllSelected(item))
    },
  }
}
</script>
<style lang="scss" scoped>
.full-box {
  display: flex;
  margin-bottom: 10px;
}
.select-container {
  display: flex;
  align-items: center;
  flex: 1;

  .select-all-checkbox {
    margin-right: 8px;
    white-space: nowrap;
  }

  .el-select {
    flex: 1;
  }
}
.full-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>
